var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"100%"},attrs:{"fluid":"","pa-0":"","ma-0":""}},[_c('CompaniesTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/views/Companies.vue?vue&type=template&id=78b3f56e&
// module id = null
// module chunks = 